(function() {
  var dataCache = {};
  var productCache = {};
  var recommendationRenderId = 0;
  var positionOrder = ['low_beam', 'high_beam', 'fog'];

  function getData(url) {
    if (!dataCache[url]) {
      dataCache[url] = fetch(url).then(function(response) {
        if (!response.ok) {
          throw new Error('Fitment data could not be loaded.');
        }
        return response.json();
      });
    }

    return dataCache[url];
  }

  function resolveFitmentDataUrl(url) {
    return String(url || '').replace(
      /fitment-data_old\.json(?:\?[^#]*)?/i,
      'fitment-data.json'
    );
  }

  function normalizeRulePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function unique(values) {
    return values.filter(function(value, index, list) {
      return value && list.indexOf(value) === index;
    });
  }

  function sortValues(values) {
    return values.sort(function(a, b) {
      if (!isNaN(a) && !isNaN(b)) {
        return Number(b) - Number(a);
      }
      return a.localeCompare(b);
    });
  }

  function setOptions(select, label, values) {
    select.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = label;
    select.appendChild(placeholder);

    values.forEach(function(value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    select.disabled = values.length === 0;
    select.value = '';
  }

  function setVehicleOptions(select, label, vehicles) {
    var seen = {};
    var options = [];

    vehicles.forEach(function(vehicle) {
      var value = getVehicleOptionValue(vehicle);
      var text = getVehiclePackageLabel(vehicle);

      if (!value || seen[value]) {
        return;
      }

      seen[value] = true;
      options.push({
        value: value,
        text: text
      });
    });

    options.sort(function(a, b) {
      return a.text.localeCompare(b.text);
    });

    select.innerHTML = '';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = label;
    select.appendChild(placeholder);

    options.forEach(function(item) {
      var option = document.createElement('option');
      option.value = item.value;
      option.textContent = item.text;
      select.appendChild(option);
    });

    select.disabled = options.length === 0;
    select.value = '';
  }

  function pushUnique(list, value) {
    if (value && list.indexOf(value) === -1) {
      list.push(value);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function readableHandle(handle) {
    return String(handle || 'Contact BRI Source')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function(character) {
        return character.toUpperCase();
      });
  }

  function getProductData(handle) {
    if (!handle) {
      return Promise.reject(new Error('Missing product handle.'));
    }

    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function(response) {
        if (!response.ok) {
          throw new Error('Product data could not be loaded.');
        }
        return response.json();
      });
    }

    return productCache[handle];
  }

  function getProductImage(product) {
    if (!product) {
      return '';
    }

    if (product.featured_image) {
      return product.featured_image;
    }

    if (product.images && product.images.length > 0) {
      return product.images[0];
    }

    return '';
  }

  function normalizeBulbText(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getBulbTokens(value) {
    return unique(normalizeBulbText(value).split(' ').filter(Boolean));
  }

  function getBulbAliases(bulbSize) {
    var tokens = getBulbTokens(bulbSize);
    var aliases = tokens.slice();
    var aliasGroups = [
      ['9005', 'HB3'],
      ['9006', 'HB4'],
      ['H10', '9140', '9145'],
      ['H11', 'H8', 'H9']
    ];

    aliasGroups.forEach(function(group) {
      var hasAlias = group.some(function(alias) {
        return tokens.indexOf(alias) !== -1;
      });

      if (hasAlias) {
        aliases = aliases.concat(group);
      }
    });

    return unique(aliases);
  }

  function getVariantFields(variant) {
    var fields = [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ];

    if (variant.options && variant.options.length) {
      fields = fields.concat(variant.options);
    }

    return fields.filter(Boolean);
  }

  function fieldHasToken(field, token) {
    return getBulbTokens(field).indexOf(token) !== -1;
  }

  function findVariantByTokens(variants, tokens, getFields) {
    var match = null;

    tokens.some(function(token) {
      match = variants.filter(function(variant) {
        return getFields(variant).some(function(field) {
          return fieldHasToken(field, token);
        });
      })[0] || null;

      return !!match;
    });

    return match;
  }

  function findVariantForBulbSize(product, bulbSize) {
    var variants = product && product.variants ? product.variants : [];
    var exactBulbSize = normalizeBulbText(bulbSize);
    var aliases = getBulbAliases(bulbSize);
    var bulbTokens = getBulbTokens(bulbSize);
    var aliasTokens = aliases.filter(function(alias) {
      return bulbTokens.indexOf(alias) === -1;
    });
    var match;

    if (!exactBulbSize || variants.length === 0) {
      return null;
    }

    match = variants.filter(function(variant) {
      return getVariantFields(variant).some(function(field) {
        return normalizeBulbText(field) === exactBulbSize;
      });
    })[0];

    if (match) {
      return match;
    }

    match = findVariantByTokens(variants, bulbTokens, getVariantFields);

    if (match) {
      return match;
    }

    match = findVariantByTokens(variants, aliasTokens, getVariantFields);

    if (match) {
      return match;
    }

    return findVariantByTokens(variants, bulbTokens, function(variant) {
      return [variant.title].filter(Boolean);
    });
  }

  function getProductUrl(handle, variant) {
    var url = '/products/' + encodeURIComponent(handle);

    if (variant && variant.id) {
      url += '?variant=' + encodeURIComponent(variant.id);
    }

    return url;
  }

  function getVariantNote(product, variant, bulbSize) {
    var variants = product && product.variants ? product.variants : [];

    if (!bulbSize || variant || variants.length <= 1) {
      return '';
    }

    return '<p class="vehicle-selector-placeholder__variant-note">Select ' + escapeHtml(bulbSize) + ' on the product page.</p>';
  }

  function isFactoryLedPosition(position) {
    var bulbSize = normalizeRulePart(position && position.bulb_size);
    var housingType = normalizeRulePart(position && position.housing_type);
    var systemType = normalizeRulePart(position && position.system_type);

    return systemType === 'factory_led' ||
      housingType === 'factory_led' ||
      bulbSize === 'led' ||
      bulbSize === 'factory_led' ||
      bulbSize === 'no_replaceable_bulb';
  }

  function formatFitmentLabel(value) {
    var labels = {
      factory_led: 'Factory LED',
      reflector: 'Reflector',
      projector: 'Projector',
      fog: 'Fog lamp',
      fog_lamp: 'Fog lamp',
      halogen: 'Halogen',
      oe_xenon: 'Factory Xenon / HID'
    };
    var key = normalizeRulePart(value);

    return labels[key] || String(value || '');
  }

  function isUnknownFitmentMetadata(value) {
    var key = normalizeRulePart(value);

    return !key ||
      key === 'unspecified' ||
      key === 'unknown' ||
      key === 'null' ||
      key === 'none' ||
      key === 'n_a' ||
      key === 'na' ||
      key === 'source_unqualified';
  }

  function getPositionDetailLabel(position) {
    var housingType = normalizeRulePart(position && position.housing_type);
    var systemType = normalizeRulePart(position && position.system_type);

    if (!position || isFactoryLedPosition(position)) {
      return '';
    }

    if (position.key === 'fog') {
      if (housingType === 'projector') {
        return 'Projector fog lamp';
      }

      if (housingType === 'reflector') {
        return 'Reflector fog lamp';
      }

      if (housingType === 'fog' || housingType === 'fog_lamp') {
        return 'Fog lamp';
      }
    }

    if (housingType && !isUnknownFitmentMetadata(housingType)) {
      return formatFitmentLabel(housingType);
    }

    if (systemType && systemType !== 'halogen' && !isUnknownFitmentMetadata(systemType)) {
      return formatFitmentLabel(systemType);
    }

    return '';
  }

  function buildFitmentIndex(data, unconfirmedCoverage) {
    var index = {
      years: {},
      yearValues: []
    };

    function addVehicle(vehicle) {
      var yearValue = vehicle.year;
      var makeValue = vehicle.make;
      var modelValue = vehicle.model;
      var optionValue = getVehicleOptionValue(vehicle);
      var yearNode;
      var makeNode;
      var modelNode;

      if (!yearValue || !makeValue || !modelValue || !optionValue) {
        return;
      }

      if (!index.years[yearValue]) {
        index.years[yearValue] = {
          makes: {},
          makeValues: []
        };
        pushUnique(index.yearValues, yearValue);
      }

      yearNode = index.years[yearValue];

      if (!yearNode.makes[makeValue]) {
        yearNode.makes[makeValue] = {
          models: {},
          modelValues: []
        };
        pushUnique(yearNode.makeValues, makeValue);
      }

      makeNode = yearNode.makes[makeValue];

      if (!makeNode.models[modelValue]) {
        makeNode.models[modelValue] = {
          vehicles: [],
          vehiclesByOption: {}
        };
        pushUnique(makeNode.modelValues, modelValue);
      }

      modelNode = makeNode.models[modelValue];

      modelNode.vehicles.push(vehicle);

      if (!modelNode.vehiclesByOption[optionValue]) {
        modelNode.vehiclesByOption[optionValue] = vehicle;
      }
    }

    data.forEach(addVehicle);

    (unconfirmedCoverage || []).forEach(function(coverage) {
      var existingModel = getModelNode(index, coverage.year, coverage.make, coverage.model);

      if (coverage.status !== 'unconfirmed' || existingModel) {
        return;
      }

      addVehicle({
        year: coverage.year,
        make: coverage.make,
        model: coverage.model,
        trim: '',
        headlight_package: 'Fitment Not Yet Confirmed',
        status: 'unconfirmed',
        priority: coverage.priority,
        reason: coverage.reason,
        notes: coverage.notes
      });
    });

    return index;
  }

  function getYearNode(index, yearValue) {
    return index && index.years ? index.years[yearValue] : null;
  }

  function getMakeNode(index, yearValue, makeValue) {
    var yearNode = getYearNode(index, yearValue);

    return yearNode && yearNode.makes ? yearNode.makes[makeValue] : null;
  }

  function getModelNode(index, yearValue, makeValue, modelValue) {
    var makeNode = getMakeNode(index, yearValue, makeValue);

    return makeNode && makeNode.models ? makeNode.models[modelValue] : null;
  }

  function findVehicle(index, selections) {
    var modelNode = getModelNode(index, selections.year, selections.make, selections.model);

    return modelNode && modelNode.vehiclesByOption ? modelNode.vehiclesByOption[selections.trimPackage] : null;
  }

  function isUnspecifiedTrim(value) {
    var key = normalizeRulePart(value);

    return !key ||
      key === 'unspecified' ||
      key === 'unspecified_trim' ||
      key === 'n_a' ||
      key === 'na' ||
      key === 'not_applicable' ||
      key === 'none' ||
      key === 'not_listed';
  }

  function formatTrimPackageLabel(trim, headlightPackage) {
    trim = String(trim || '').trim();
    headlightPackage = String(headlightPackage || '').trim();

    if (isUnspecifiedTrim(trim)) {
      return headlightPackage || 'Standard Headlight Package';
    }

    if (trim && headlightPackage) {
      return trim + ', ' + headlightPackage;
    }

    return trim || headlightPackage || 'Standard Headlight Package';
  }

  function getVehiclePackageLabel(vehicle) {
    var trim = vehicle && vehicle.trim ? vehicle.trim : '';
    var headlightPackage = vehicle && vehicle.headlight_package ? vehicle.headlight_package : '';

    return formatTrimPackageLabel(trim, headlightPackage);
  }

  function getVehicleOptionValue(vehicle) {
    if (!vehicle) {
      return '';
    }

    return [
      vehicle.trim || '',
      vehicle.headlight_package || ''
    ].join('||');
  }

  function getVehicleSummary(vehicle) {
    return formatSelectedVehicleLabel(vehicle);
  }

  function isUnconfirmedVehicle(vehicle) {
    return normalizeRulePart(vehicle && vehicle.status) === 'unconfirmed';
  }

  function formatSelectedVehicleLabel(vehicle) {
    return [
      vehicle.year,
      vehicle.make,
      vehicle.model,
      getVehiclePackageLabel(vehicle)
    ].filter(Boolean).join(' ');
  }

  function hasPositionFitment(position) {
    if (!position) {
      return false;
    }

    if (typeof position === 'string') {
      return !!position.trim();
    }

    return !!String(position.bulb_size || '').trim();
  }

  function isKnownDualBeamBulb(value) {
    var dualBeamBulbs = {
      h4: true,
      '9003': true,
      '9003_h4': true,
      '9004': true,
      '9007': true,
      '9008_h13': true,
      h13: true
    };

    return !!dualBeamBulbs[normalizeRulePart(value)];
  }

  function hasDualBeamSignal(position, vehicle) {
    var signalText = [
      position && position.beam_configuration,
      position && position.notes,
      vehicle && vehicle.beam_configuration,
      vehicle && vehicle.notes
    ].filter(Boolean).join(' ').toLowerCase();

    return normalizeRulePart(position && position.beam_configuration) === 'dual_beam_confirmed' ||
      normalizeRulePart(vehicle && vehicle.beam_configuration) === 'dual_beam_confirmed' ||
      signalText.indexOf('dual-beam bulb handles low and high beam') !== -1 ||
      isKnownDualBeamBulb(position && position.bulb_size);
  }

  function isDualBeamLowPosition(key, position, vehicle) {
    var highBeamPosition = vehicle && vehicle.positions ? vehicle.positions.high_beam : null;

    return key === 'low_beam' &&
      !hasPositionFitment(highBeamPosition) &&
      !isFactoryLedPosition(position) &&
      hasDualBeamSignal(position, vehicle);
  }

  function getPositionLabel(key, position, vehicle) {
    if (isDualBeamLowPosition(key, position, vehicle)) {
      return 'Low / High Beam';
    }

    return position && position.label ? position.label : key.replace(/_/g, ' ');
  }

  function getPositionEntries(vehicle) {
    if (!vehicle || !vehicle.positions) {
      return [];
    }

    return positionOrder.filter(function(key) {
      return hasPositionFitment(vehicle.positions[key]);
    }).map(function(key) {
      var position = vehicle.positions[key];

      if (typeof position === 'string') {
        return {
          key: key,
          label: getPositionLabel(key, { bulb_size: position }, vehicle),
          bulb_size: position,
          housing_type: '',
          system_type: '',
          confidence: '',
          notes: '',
          recommendation_overrides: [],
          recommended_options: []
        };
      }

      return {
        key: key,
        label: getPositionLabel(key, position, vehicle),
        bulb_size: position.bulb_size,
        housing_type: position.housing_type,
        system_type: position.system_type,
        confidence: position.confidence,
        notes: position.notes,
        recommendation_overrides: position.recommendation_overrides,
        recommended_options: position.recommended_options
      };
    });
  }

  function getSummaryPositionEntries(vehicle) {
    return getPositionEntries(vehicle);
  }

  function getPositionByKey(positions, key) {
    return positions.filter(function(position) {
      return position.key === key;
    })[0];
  }

  function getRuleKey(position) {
    var system = normalizeRulePart(position.system_type || 'halogen');

    if (system === 'oe_xenon') {
      return system + '_' + position.key;
    }

    if (position.key === 'fog') {
      return system + '_fog';
    }

    return [
      system,
      normalizeRulePart(position.housing_type),
      position.key
    ].join('_');
  }

  function isDeterministicReplaceableBulb(position) {
    var bulbSize = String(position && position.bulb_size || '').trim();
    var key = normalizeRulePart(bulbSize);
    var confidence = normalizeRulePart(position && position.confidence);

    if (!bulbSize || isFactoryLedPosition(position)) {
      return false;
    }

    if (confidence === 'review' ||
      confidence === 'conflict' ||
      confidence === 'needs_review' ||
      key === 'n_a' ||
      key === 'na' ||
      key === 'assembly' ||
      key === 'assembly_only' ||
      key === 'not_listed' ||
      key === 'unknown' ||
      key === 'confirm_with_bri_source' ||
      /\s+OR\s+/i.test(bulbSize)) {
      return false;
    }

    return isDSeriesBulb(bulbSize) || getBulbCollectionHandle(bulbSize) !== 'other-bulb-sizes';
  }

  function isDSeriesBulb(value) {
    return getBulbTokens(value).some(function(token) {
      return /^D[1-8][RS]$/.test(token);
    });
  }

  function getRecommendationRuleKeys(position) {
    var keys = [];

    if (!position || !isDeterministicReplaceableBulb(position)) {
      return keys;
    }

    pushUnique(keys, getRuleKey(position));

    if (isDSeriesBulb(position.bulb_size) && position.key !== 'fog') {
      pushUnique(keys, 'oe_xenon_' + position.key);
    }

    pushUnique(keys, 'replaceable_' + position.key);
    return keys;
  }

  function getRecommendationsForPosition(position, rulesData) {
    var rules = rulesData && rulesData.rules ? rulesData.rules : {};
    var ruleKeys = getRecommendationRuleKeys(position);
    var recommendations = [];

    if (!position || isFactoryLedPosition(position)) {
      return recommendations;
    }

    if (position.recommendation_overrides && position.recommendation_overrides.length > 0) {
      recommendations = position.recommendation_overrides;
    } else if (position.recommended_options && position.recommended_options.length > 0) {
      recommendations = position.recommended_options;
    } else {
      ruleKeys.some(function(ruleKey) {
        if (rules[ruleKey]) {
          recommendations = rules[ruleKey];
          return true;
        }
        return false;
      });
    }

    return recommendations.slice().sort(function(a, b) {
      return (a.priority || 999) - (b.priority || 999);
    });
  }

  function renderLegalUseDisclaimer() {
    return [
      '<p class="vehicle-selector-placeholder__legal-disclaimer">',
      'Fitment and product recommendations are provided as a starting point. Some LED and HID upgrades may be intended for off-road, show, auxiliary, or permitted-use applications only. Check local laws before using upgraded forward lighting on public roads.',
      '</p>'
    ].join('');
  }

  function renderUnconfirmedFitment(container, vehicle) {
    var note = vehicle && vehicle.reason ? vehicle.reason : 'Fitment details are still being reviewed for this vehicle.';

    container.innerHTML = [
      '<article class="vehicle-selector-placeholder__unconfirmed">',
      '<p class="vehicle-selector-placeholder__factory-led-heading">Fitment Review Needed</p>',
      '<h4>Contact us to confirm fitment</h4>',
      '<p>Fitment for this vehicle has not been confirmed yet. Contact a BRI Source lighting expert and we&rsquo;ll help verify the correct low beam, high beam, and fog light options before you order.</p>',
      '<p class="vehicle-selector-placeholder__unconfirmed-note">' + escapeHtml(note) + '</p>',
      '<a class="vehicle-selector-placeholder__contact-link" href="/pages/contact-us">Contact us for help confirming fitment</a>',
      '</article>'
    ].join('');
  }

  function getBulbCollectionHandle(bulbSize) {
    var value = String(bulbSize || '').trim();
    var key = normalizeRulePart(value);
    var dSeriesToken = getBulbTokens(value).filter(function(token) {
      return /^D[1-8][RS]$/.test(token);
    })[0];
    var collectionHandles = {
      h1: 'h1-headlight-foglight-bulbs',
      h3: 'h3-headlight-foglight-bulbs',
      h4: 'h4-headlight-bulbs',
      h7: 'h7-headlight-bulbs',
      h8: 'h8-foglight-bulbs',
      h9: 'h9-headlight-bulbs',
      h10: 'h10-foglight-bulbs',
      h10_9145: 'h10-foglight-bulbs',
      h11: 'h11-headlight-bulbs',
      h13: 'h13-headlight-bulbs',
      h15: 'h15-headlight-bulbs',
      h16: 'h16-headlight-bulbs',
      '9003': '9003-headlight-bulbs',
      '9003_h4': '9003-headlight-bulbs',
      '9004': '9004-headlight-bulbs',
      '9005': '9005-headlight-bulbs',
      '9005_hb3': '9005-headlight-bulbs',
      '9006': '9006-headlight-foglight-bulbs',
      '9006_hb4': '9006-headlight-foglight-bulbs',
      '9007': '9007-headlight-bulbs',
      '9008': 'h13-headlight-bulbs',
      '9008_h13': 'h13-headlight-bulbs',
      '9011': '9011-headlight-bulbs',
      '9012': '9012-headlight-bulbs',
      '9012_hir2': '9012-headlight-bulbs',
      '880': '880-foglight-bulbs',
      '800': '880-foglight-bulbs',
      '5202': '5202-foglight-bulbs',
      '2504': '5202-foglight-bulbs',
      '9145': '9145-fog-light-bulbs',
      d1s: 'd1s-headlight-bulbs',
      d2s: 'd2s-headlight-bulbs',
      d3s: 'd3s-headlight-bulbs',
      d4s: 'd4s-headlight-bulbs',
      d5s: 'd5s-headlight-bulbs',
      '1156': '1156-bulbs',
      '1157': '1157-bulbs',
      '3156': '3156-bulbs',
      '3157': '3157-bulbs',
      '7440': '7440-bulbs',
      '7443': '7443-bulbs',
      '194_168_t10': '194-168-t10-bulbs',
      '921_912_t15': '921-912-t15-bulbs'
    };

    if (!value ||
      key === 'not_listed' ||
      key === 'factory_led' ||
      key === 'confirm_with_bri_source') {
      return '';
    }

    if (dSeriesToken) {
      return 'd' + dSeriesToken.charAt(1).toLowerCase() + 's-headlight-bulbs';
    }

    return collectionHandles[key] || 'other-bulb-sizes';
  }

  function renderBulbSizeValue(position) {
    var bulbSize = position && position.bulb_size ? position.bulb_size : '';
    var handle = getBulbCollectionHandle(bulbSize);

    if (!handle) {
      return escapeHtml(bulbSize);
    }

    return [
      '<a class="vehicle-selector-placeholder__bulb-link" href="/collections/',
      encodeURIComponent(handle),
      '" aria-label="Shop ',
      escapeHtml(bulbSize),
      ' bulbs">',
      escapeHtml(bulbSize),
      '</a>'
    ].join('');
  }

  function renderSummary(container, positions) {
    if (positions.length === 0) {
      container.innerHTML = '<p class="vehicle-selector-placeholder__empty">No published bulb fitment is available for this selection.</p>';
      return;
    }

    container.innerHTML = positions.map(function(position) {
      var detailLabel = getPositionDetailLabel(position);

      return [
        '<div>',
        '<dt>' + escapeHtml(position.label) + '</dt>',
        '<dd>' + renderBulbSizeValue(position) + '</dd>',
        detailLabel ? '<p class="vehicle-selector-placeholder__housing-note">' + escapeHtml(detailLabel) + '</p>' : '',
        '</div>'
      ].join('');
    }).join('');
  }

  function renderTabs(container, positions, activeKey) {
    container.innerHTML = positions.map(function(position) {
      var isActive = position.key === activeKey;

      return [
        '<button type="button" class="vehicle-selector-placeholder__tab',
        isActive ? ' vehicle-selector-placeholder__tab--active' : '',
        '" data-position-key="' + escapeHtml(position.key) + '" aria-pressed="' + (isActive ? 'true' : 'false') + '">',
        escapeHtml(position.label),
        '</button>'
      ].join('');
    }).join('');
  }

  function renderConfidenceNote(container, vehicle) {
    var messages = {
      confirmed: 'CONFIRMED FITMENT — Confirmed fitment for this factory lighting configuration.',
      likely: 'LIKELY FITMENT — Likely fitment. Factory lighting packages can vary, so confirm your existing bulb or headlight type before ordering.',
      possible: 'POSSIBLE FITMENT — Possible fitment with limited source confirmation. Verify your existing bulb before ordering.'
    };

    if (!container) {
      return;
    }

    if (messages[vehicle.confidence]) {
      container.textContent = messages[vehicle.confidence];
      return;
    }

    if (vehicle.confidence === 'needs-confirmation') {
      container.textContent = 'Fitment needs confirmation. Some trims and packages may vary.';
      return;
    }

    container.textContent = '';
  }

  function renderRecommendations(container, position, rulesData) {
    var recommendations = getRecommendationsForPosition(position, rulesData);
    var renderId = String(++recommendationRenderId);
    var selectedBulbSize = position && position.bulb_size ? position.bulb_size : '';

    if (isFactoryLedPosition(position)) {
      container.innerHTML = [
        '<article class="vehicle-selector-placeholder__factory-led">',
        '<p class="vehicle-selector-placeholder__factory-led-heading">Factory LED Lighting</p>',
        '<h4>No standard bulb recommendation</h4>',
        '<p>Factory LED headlights may not use standard replaceable bulbs. Contact a BRI Source lighting expert if you want help confirming upgrade options.</p>',
        '</article>'
      ].join('');
      return;
    }

    if (!recommendations || recommendations.length === 0) {
      container.innerHTML = '<p class="vehicle-selector-placeholder__empty">Need help choosing? Contact a BRI Source lighting expert and we\'ll point you toward the right option.</p>';
      return;
    }

    container.dataset.recommendationRenderId = renderId;
    container.innerHTML = recommendations.map(function(item) {
      if (!item.handle) {
        return [
          '<article class="vehicle-selector-placeholder__card">',
          '<p class="vehicle-selector-placeholder__card-label">' + escapeHtml(item.label || 'Need help choosing?') + '</p>',
          '<h4 class="vehicle-selector-placeholder__product">Contact BRI Source</h4>',
          '<p>' + escapeHtml(item.reason || 'Contact a BRI Source lighting expert and we\'ll point you toward the right option.') + '</p>',
          '</article>'
        ].join('');
      }

      return [
        '<article class="vehicle-selector-placeholder__card vehicle-selector-placeholder__card--loading" data-product-handle="' + escapeHtml(item.handle) + '">',
        '<div class="vehicle-selector-placeholder__product-media vehicle-selector-placeholder__product-media--loading" aria-hidden="true"></div>',
        '<div class="vehicle-selector-placeholder__product-info">',
        '<p class="vehicle-selector-placeholder__card-label">' + escapeHtml(item.label) + '</p>',
        '<h4 class="vehicle-selector-placeholder__product">' + escapeHtml(readableHandle(item.handle)) + '</h4>',
        '<p>' + escapeHtml(item.reason || 'Need help choosing? Contact a BRI Source lighting expert.') + '</p>',
        '<a class="btn btn--secondary vehicle-selector-placeholder__card-button" href="' + escapeHtml(getProductUrl(item.handle)) + '">View product</a>',
        '</div>',
        '</article>'
      ].join('');
    }).join('') + renderLegalUseDisclaimer();

    recommendations.forEach(function(item) {
      if (!item.handle) {
        return;
      }

      getProductData(item.handle).then(function(product) {
        var card = container.querySelector('[data-product-handle="' + item.handle + '"]');
        var image = getProductImage(product);
        var matchedVariant = findVariantForBulbSize(product, selectedBulbSize);
        var productUrl = getProductUrl(item.handle, matchedVariant);
        var variantNote = getVariantNote(product, matchedVariant, selectedBulbSize);

        if (container.dataset.recommendationRenderId !== renderId || !card) {
          return;
        }

        card.classList.remove('vehicle-selector-placeholder__card--loading');
        card.innerHTML = [
          image ? '<div class="vehicle-selector-placeholder__product-media"><img class="vehicle-selector-placeholder__product-image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title || readableHandle(item.handle)) + '" loading="lazy"></div>' : '<div class="vehicle-selector-placeholder__product-media vehicle-selector-placeholder__product-media--empty" aria-hidden="true"></div>',
          '<div class="vehicle-selector-placeholder__product-info">',
          '<p class="vehicle-selector-placeholder__card-label">' + escapeHtml(item.label) + '</p>',
          '<h4 class="vehicle-selector-placeholder__product">' + escapeHtml(product.title || readableHandle(item.handle)) + '</h4>',
          '<p>' + escapeHtml(item.reason || 'Need help choosing? Contact a BRI Source lighting expert.') + '</p>',
          variantNote,
          '<a class="btn btn--secondary vehicle-selector-placeholder__card-button" href="' + escapeHtml(productUrl) + '">View product</a>',
          '</div>'
        ].join('');
      }).catch(function() {
        var card = container.querySelector('[data-product-handle="' + item.handle + '"]');

        if (container.dataset.recommendationRenderId !== renderId || !card) {
          return;
        }

        card.classList.remove('vehicle-selector-placeholder__card--loading');
        card.innerHTML = [
          '<div class="vehicle-selector-placeholder__product-media vehicle-selector-placeholder__product-media--empty" aria-hidden="true"></div>',
          '<div class="vehicle-selector-placeholder__product-info">',
          '<p class="vehicle-selector-placeholder__card-label">' + escapeHtml(item.label) + '</p>',
          '<h4 class="vehicle-selector-placeholder__product">' + escapeHtml(readableHandle(item.handle)) + '</h4>',
          '<p>' + escapeHtml(item.reason || 'Need help choosing? Contact a BRI Source lighting expert.') + '</p>',
          '<a class="btn btn--secondary vehicle-selector-placeholder__card-button" href="' + escapeHtml(getProductUrl(item.handle)) + '">View product</a>',
          '</div>'
        ].join('');
      });
    });
  }

  function setActiveTab(container, key) {
    Array.prototype.forEach.call(container.querySelectorAll('[data-position-key]'), function(button) {
      var isActive = button.getAttribute('data-position-key') === key;
      button.classList.toggle('vehicle-selector-placeholder__tab--active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function findPositionButton(node, root) {
    while (node && node !== root) {
      if (node.getAttribute && node.getAttribute('data-position-key')) {
        return node;
      }
      node = node.parentNode;
    }

    return null;
  }

  function initSelector(root) {
    if (!root || root.dataset.vehicleSelectorReady === 'true') {
      return;
    }

    var dataUrl = resolveFitmentDataUrl(root.dataset.fitmentUrl);
    var coverageUrl = root.dataset.coverageUrl;
    var rulesUrl = root.dataset.rulesUrl;
    var year = root.querySelector('[data-vehicle-year]');
    var make = root.querySelector('[data-vehicle-make]');
    var model = root.querySelector('[data-vehicle-model]');
    var trim = root.querySelector('[data-vehicle-trim]');
    var submit = root.querySelector('[data-vehicle-submit]');
    var status = root.querySelector('[data-vehicle-status]');
    var fallback = root.querySelector('[data-vehicle-fallback]');
    var results = root.querySelector('[data-vehicle-results]');
    var resultHeading = root.querySelector('[data-result-heading]');
    var resultVehicle = root.querySelector('[data-result-vehicle]');
    var resultSummary = root.querySelector('[data-result-summary]');
    var resultTabs = root.querySelector('[data-result-tabs]');
    var resultConfidence = root.querySelector('[data-result-confidence]');
    var resultRecommendations = root.querySelector('[data-result-recommendations]');
    var trimLabel = trim ? trim.getAttribute('data-vehicle-trim-label') || 'Trim / Headlight Package' : 'Trim / Headlight Package';
    var currentPositions = [];

    if (!dataUrl || !rulesUrl || !year || !make || !model || !trim || !submit || !fallback || !results || !resultSummary || !resultTabs || !resultRecommendations) {
      return;
    }

    root.dataset.vehicleSelectorReady = 'true';
    // fitment-data.json controls vehicle bulb sizes, housing type, and system type.
    // recommendation-rules.json controls general product recommendations.
    // Product title/image are fetched automatically from Shopify with /products/{handle}.js.
    // The fitment JSON stays as a reviewable array, then gets indexed here for fast year/make/model lookups.
    var rulesData = {};

    function clearResult() {
      currentPositions = [];
      results.classList.add('vehicle-selector-placeholder__results--hidden');
    }

    function renderVehicleResult(vehicle) {
      var activeKey;
      var summaryPositions;

      if (isUnconfirmedVehicle(vehicle)) {
        currentPositions = [];
        resultHeading.textContent = 'Fitment not yet confirmed';
        resultVehicle.textContent = getVehicleSummary(vehicle);
        resultSummary.innerHTML = [
          '<div>',
          '<dt>Status</dt>',
          '<dd>Contact us to confirm fitment</dd>',
          '</div>'
        ].join('');
        resultTabs.innerHTML = '';
        renderConfidenceNote(resultConfidence, vehicle);
        renderUnconfirmedFitment(resultRecommendations, vehicle);
        results.classList.remove('vehicle-selector-placeholder__results--hidden');
        fallback.classList.add('vehicle-selector-placeholder__fallback--hidden');
        return;
      }

      currentPositions = getPositionEntries(vehicle);
      summaryPositions = getSummaryPositionEntries(vehicle);
      activeKey = currentPositions.length > 0 ? currentPositions[0].key : '';

      resultHeading.textContent = 'Fitment match';
      resultVehicle.textContent = getVehicleSummary(vehicle);
      renderSummary(resultSummary, summaryPositions);
      renderTabs(resultTabs, currentPositions, activeKey);
      renderConfidenceNote(resultConfidence, vehicle);
      renderRecommendations(resultRecommendations, getPositionByKey(currentPositions, activeKey), rulesData);
      results.classList.remove('vehicle-selector-placeholder__results--hidden');
      fallback.classList.add('vehicle-selector-placeholder__fallback--hidden');
    }

    resultTabs.addEventListener('click', function(event) {
      var button = findPositionButton(event.target, resultTabs);
      var key = button && button.getAttribute('data-position-key');
      var position = key && getPositionByKey(currentPositions, key);

      if (!position) {
        return;
      }

      setActiveTab(resultTabs, key);
      renderRecommendations(resultRecommendations, position, rulesData);
    });

    Promise.all([
      getData(dataUrl),
      getData(rulesUrl),
      coverageUrl ? getData(coverageUrl).catch(function() { return []; }) : Promise.resolve([])
    ]).then(function(responses) {
      var data = responses[0];
      var unconfirmedCoverage = responses[2] || [];
      var fitmentIndex = buildFitmentIndex(data, unconfirmedCoverage);
      rulesData = responses[1] || {};

      setOptions(year, 'Year', sortValues(fitmentIndex.yearValues.slice()));

      year.addEventListener('change', function() {
        var yearNode = getYearNode(fitmentIndex, year.value);
        var makes = yearNode ? yearNode.makeValues.slice() : [];

        setOptions(make, 'Make', sortValues(makes));
        setOptions(model, 'Model', []);
        setOptions(trim, trimLabel, []);
        status.textContent = '';
        clearResult();
      });

      make.addEventListener('change', function() {
        var makeNode = getMakeNode(fitmentIndex, year.value, make.value);
        var models = makeNode ? makeNode.modelValues.slice() : [];

        setOptions(model, 'Model', sortValues(models));
        setOptions(trim, trimLabel, []);
        status.textContent = '';
        clearResult();
      });

      model.addEventListener('change', function() {
        var modelNode = getModelNode(fitmentIndex, year.value, make.value, model.value);
        var trimVehicles = modelNode ? modelNode.vehicles : [];

        setVehicleOptions(trim, trimLabel, trimVehicles);
        status.textContent = '';
        clearResult();
      });

      trim.addEventListener('change', function() {
        status.textContent = '';
        clearResult();
      });

      submit.addEventListener('click', function() {
        var selections = {
          year: year.value,
          make: make.value,
          model: model.value,
          trimPackage: trim.value
        };
        var vehicle = findVehicle(fitmentIndex, selections);

        if (!vehicle) {
          status.textContent = 'Choose a year, make, model, and trim to see recommendations.';
          clearResult();
          fallback.classList.remove('vehicle-selector-placeholder__fallback--hidden');
          return;
        }

        renderVehicleResult(vehicle);
        status.textContent = '';
      });
    }).catch(function() {
      status.textContent = 'Vehicle sample data is not available right now.';
    });
  }

  function initAll(container) {
    var scope = container || document;
    var selectors = scope.querySelectorAll('[data-section-type="vehicle-selector-placeholder"]');
    Array.prototype.forEach.call(selectors, initSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
